class ProductClothingTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-compact-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-compact-panel]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab, false));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
    });
  }

  activate(activeTab, moveFocus) {
    const activePanelId = activeTab.getAttribute('aria-controls');

    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== activePanelId;
    });

    if (moveFocus) activeTab.focus();
  }

  onKeydown(event, currentTab) {
    const currentIndex = this.tabs.indexOf(currentTab);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;
    if (nextIndex === currentIndex) return;

    event.preventDefault();
    this.activate(this.tabs[nextIndex], true);
  }
}

if (!customElements.get('product-clothing-tabs')) {
  customElements.define('product-clothing-tabs', ProductClothingTabs);
}

function decorateCompactProduct() {
  document.querySelectorAll('[data-product-clothing-compact-hook]').forEach((hook) => {
    const formWrapper = hook.closest('.form__wrapper');
    if (!formWrapper || formWrapper.dataset.compactDecorated === 'true') return;

    formWrapper.dataset.compactDecorated = 'true';
    formWrapper.classList.add('product-clothing-compact__form-wrapper');

    if (formWrapper.hasAttribute('data-compact-look-sticky') && 'ResizeObserver' in window) {
      const header = document.querySelector('[data-header-sticky][data-header-height]');
      const product = formWrapper.closest('product-component');
      let gallery = product?.querySelector('.product-gallery');
      const track = formWrapper.querySelector('.compact-look-purchase-track');
      const panel = track?.querySelector('.compact-look-purchase');
      const title = panel?.querySelector('h1');
      if (gallery && panel) {
        const updateSticky = () => {
          const headerBottom = Math.ceil(header?.getBoundingClientRect().height || 0) + 16;
          const titleOffset = title ? title.getBoundingClientRect().top - panel.getBoundingClientRect().top : 0;
          const top = headerBottom - titleOffset;
          const galleryEnd = gallery.getBoundingClientRect().bottom - track.getBoundingClientRect().top;
          formWrapper.style.setProperty('--compact-look-sticky-top', `${top}px`);
          formWrapper.style.setProperty('--compact-look-gallery-end', `${galleryEnd}px`);
          formWrapper.style.setProperty('--compact-look-panel-height', `${panel.offsetHeight}px`);
        };
        const stickyObserver = new ResizeObserver(updateSticky);
        stickyObserver.observe(gallery);
        stickyObserver.observe(panel);
        if (header) stickyObserver.observe(header);
        const onGalleryLoaded = () => {
          if (!formWrapper.isConnected) {
            stickyObserver.disconnect();
            document.removeEventListener('variant:gallery:loaded', onGalleryLoaded);
            return;
          }
          const currentGallery = product.querySelector('.product-gallery');
          if (!currentGallery || currentGallery === gallery) return;

          stickyObserver.unobserve(gallery);
          gallery = currentGallery;
          stickyObserver.observe(gallery);
          updateSticky();
        };
        document.addEventListener('variant:gallery:loaded', onGalleryLoaded);
        updateSticky();
        formWrapper.classList.add('is-compact-look-sticky');
      }
    }

    const decorateFavorite = () => {
      const favoriteButton = formWrapper.querySelector('klaviyo-favorites-button');
      const favoriteBlock = favoriteButton?.closest('.standard__app');
      if (!favoriteBlock) return false;

      favoriteBlock.classList.add('product-clothing-compact__wishlist');
      const titleBlock = formWrapper.querySelector('.product__title-and-price');

      const alignFavorite = () => {
        if (!titleBlock) return;

        const favoriteTop = titleBlock.offsetTop
          + Math.max(0, (titleBlock.offsetHeight - favoriteBlock.offsetHeight) / 2);
        favoriteBlock.style.setProperty('--compact-wishlist-top', `${favoriteTop}px`);
      };

      alignFavorite();
      window.requestAnimationFrame(alignFavorite);

      if (titleBlock && 'ResizeObserver' in window) {
        const favoriteAlignmentObserver = new ResizeObserver(alignFavorite);
        favoriteAlignmentObserver.observe(titleBlock);
        favoriteAlignmentObserver.observe(favoriteBlock);
      }

      return true;
    };

    if (!decorateFavorite()) {
      const favoriteObserver = new MutationObserver(() => {
        if (!decorateFavorite()) return;
        favoriteObserver.disconnect();
      });
      favoriteObserver.observe(formWrapper, { childList: true, subtree: true });
      window.setTimeout(() => favoriteObserver.disconnect(), 10000);
    }

    const trustLabels = [
      'Leverans inom 1–3 dagar',
      '14 dagars ångerrätt',
      'Samma lager online & i butik',
    ];
    const trustBlocks = Array.from(formWrapper.querySelectorAll('.product__icon__row'))
      .filter((row) => trustLabels.includes(row.textContent.trim()))
      .map((row) => row.closest('.product__block'))
      .filter(Boolean);

    trustBlocks.forEach((block, index) => {
      block.classList.add('product-clothing-compact__trust-item');
      if (index === 0) block.classList.add('product-clothing-compact__trust-item--first');
      if (index === trustBlocks.length - 1) block.classList.add('product-clothing-compact__trust-item--last');
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', decorateCompactProduct, { once: true });
} else {
  decorateCompactProduct();
}
